import * as React from "react";
import * as CH from "@chakra-ui/react";
import { IconType } from "react-icons/lib";
import * as SR from "slate-react";
import {
  NumberedList,
  BulletedList,
  isActiveElementOfType
} from "../../../../duck";
import { restoreSelection } from "../../duck";
import { toggleList } from "./duck";

const ListButton: React.FC<{
  title: string;
  icon: IconType;
  listType: NumberedList["type"] | BulletedList["type"];
}> = ({ title, icon, listType }) => {
  const editor = SR.useSlate();
  const isActive = isActiveElementOfType(editor, listType);

  const handleClick = () => {
    toggleList(editor, listType, !isActive);
    restoreSelection(editor);
  };

  return (
    <CH.IconButton
      size="sm"
      colorScheme="gray"
      title={title}
      aria-label={title}
      icon={<CH.Icon as={icon} />}
      onClick={handleClick}
      variant={isActive ? undefined : "ghost"}
    />
  );
};

export default ListButton;
